var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {CreateBrandAsync as InvokeAsync , CreateBrandSync as InvokeSync}

async function CreateBrandAsync(LoginToken,BrandName)
{
    var CreateBrandPromise = new Promise((resolve, reject) => {
        CreateBrandSync(LoginToken,BrandName,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await CreateBrandPromise;
}

function CreateBrandSync(LoginToken,BrandName,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/CreateBrand',                
        data   : {
            AppID     :KEYS.AWS_APPID,
            BrandName :BrandName ,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
